export const microCardActivation = {
    enabled: false,
    _description: 'Enables the micro card activation feature on bank card settings page.',
};
